import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import './table-view/column-setting';

Component('tr-project-table-view', {
  mixins: [eventListenerMixin],

  properties: {
    fullsize: {
      type: Boolean,
      default: false,
    },
  },

  connected() {
    const headerNav = document.querySelector('#nav-project');
    if (headerNav) headerNav.classList.add('active');

    document.body.classList.add('body-table-view');
    if (this.fullsize) document.body.classList.add('body-fullscreen');

    this.listenTo(document.querySelector('tr-project-kanban-toolbar'), {
      'tao:fullscreen': this.handleFullscreenChange.bind(this),
    });

    this.table = this.querySelector('tr-project-table-view-todo-table');
    this.toolbar = this.querySelector('tr-project-table-view-toolbar');

    this.listenTo(this.table, {
      'tao:selectedRowsChange': (event) => {
        this.toolbar.selectedIds = event.detail;
      },
      'tao:removeRows': (event) => {
        event.detail.forEach(id => this.toolbar.removeSelectedId(id));
      },
      'tao:handsontableInit': () => {
        this.toolbar.totalRows = this.table.getTotalRows();
        this.showColumnSettingWrapper();
      },
      'tao:scrollHorizontally': this.updateColumnSettingWrapperWidth.bind(this),
    });

    this.listenTo(this.toolbar, {
      'tao:close': () => this.table.clearSelectedRows(),
    });
  },

  disconnected() {
    document.body.classList.remove('body-table-view');
    this.stopListening();
  },

  handleFullscreenChange(event) {
    if (event.detail && this.table) this.table.rerender();
  },

  showColumnSettingWrapper() {
    this.columnSettingWrapper = this.querySelector('.column-setting-wrapper');
    if (!this.columnSettingWrapper) return;

    this.columnSettingWrapper.classList.remove('hidden');
    this.columnSettingWrapperWidth = this.columnSettingWrapper.offsetWidth;

    this.updateColumnSettingWrapperWidth();
    const featurePopover = this.querySelector('tr-feature-popover');
    if (featurePopover) featurePopover.show();
  },

  updateColumnSettingWrapperWidth() {
    if (!this.columnSettingWrapper) return;

    const { clientWidth } = document.documentElement;
    const scrollX = this.table.getTableScrollX();

    if (scrollX + this.columnSettingWrapperWidth <= clientWidth) {
      const width = Math.max(this.columnSettingWrapperWidth, clientWidth - scrollX + 1);
      this.columnSettingWrapper.style.width = `${width}px`;
    } else {
      this.columnSettingWrapper.style.width = '';
    }
  },
});
